import { Directive, HostListener, ElementRef } from '@angular/core';


@Directive({
    selector: 'input[phoneMask]'
})

export class PhoneMaskDirective {

    constructor(private el: ElementRef) { }

    @HostListener('input', ['$event'])
    onInputChange(event: KeyboardEvent) {
        let value = this.el.nativeElement.value;

        // Elimina caracteres no numéricos
        value = value.replace(/\D/g, '');

        // Aplica formato
        if (value.length > 3 && value.length <= 6) {
            value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else if (value.length > 6) {
            value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
        }

        this.el.nativeElement.value = value;
    }
}
